import * as React from "react";
const SvgTranslate01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.005 9.243a1.5 1.5 0 0 1 .99 0l.157.066.127.07c.279.176.438.424.523.566.106.179.215.409.322.632l4.778 9.991a1 1 0 0 1-1.804.864L19.456 18h-5.912l-1.642 3.432a1 1 0 0 1-1.804-.864l4.778-9.99c.107-.224.216-.454.322-.633.097-.162.291-.463.65-.636zM7 3a1 1 0 0 1 2 0v1h5a1 1 0 1 1 0 2h-1.674a19 19 0 0 1-2.762 6.635q.43.266.846.453a1 1 0 0 1-.82 1.824 9.6 9.6 0 0 1-1.228-.67 18.3 18.3 0 0 1-5.917 4.653 1 1 0 0 1-.89-1.79 16.3 16.3 0 0 0 5.22-4.08c-1.14-1.03-2.135-2.309-2.696-3.635a1 1 0 0 1 1.842-.78c.405.959 1.152 1.954 2.055 2.801A17 17 0 0 0 10.277 6H2a1 1 0 0 1 0-2h5zm7.5 13h4l-2-4.183z"
}));
export default SvgTranslate01;
//# sourceMappingURL=Translate01.js.map